import request from '@/utils/request'

//获取VIP价格列表
export function api_vipPriceList(params){
  return request({
    url: '/publicszoneui.service/UserService/getVipPriceList',
    method: 'get',
    params: {
      ...params
    }
  })
}

//获取VIP价格列表
  export function api_getCouponList(data){
  return request({
    url: '/publicszoneui.service/UserService/CouponList',
    method: 'post',
    data
  })
}
